import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DailyWorkingHour } from '../models/daily-working-hour';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DailyWorkingHourService {

  private api = environment.apiUrl + '/schedule';

  constructor(private http: HttpClient) {}

  generate(periodId: number): Observable<DailyWorkingHour[]> {
    return this.http.get<DailyWorkingHour[]>(`${this.api}/generate/${periodId}`);
  }

  getByPeriod(periodId: number): Observable<DailyWorkingHour[]> {
    return this.http.get<DailyWorkingHour[]>(`${this.api}/${periodId}`);
  }

  save(periodId: number, payload: any) {
  return this.http.post(`${this.api}/${periodId}`, payload);
}

  

}
